import { memo } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './Style';
import { getSegmentIntervalTime } from '../../../helpers/utils';
const SegmentDevider = ({
  transferTime,
  isDashed
}) => /*#__PURE__*/React.createElement(Styled.SegmentPointsDevider, {
  isDashed: isDashed
}, /*#__PURE__*/React.createElement(React.Fragment, null, I18n.t('pages.search.trip.self_transfer'), transferTime && /*#__PURE__*/React.createElement("span", null, `, ${getSegmentIntervalTime(transferTime)}`)));
SegmentDevider.propTypes = {
  transferTime: PropTypes.string,
  isDashed: PropTypes.bool
};
export default /*#__PURE__*/memo(SegmentDevider);